type OwnProps = {
  id?: string;
  className?: string;
  style?: $TSFixMe;
  children?: React.ReactNode;
};

const defaultProps: Partial<OwnProps> = {
  id: undefined,
  className: undefined,
  style: undefined,
  children: undefined,
};

type Props = OwnProps & typeof defaultProps;

function Container({ className, style, children, id }: Props) {
  return (
    <div
      id={id}
      className={["container", className].filter((c) => c).join(" ")}
      style={style}
    >
      {children}
    </div>
  );
}

Container.defaultProps = defaultProps;

export default Container;
